import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import {get} from "../../network/axiosServices";


const initialState = {
    loading: false,
    posts: [],
    error: '',
}

export const fetchExecutiveCouncil = createAsyncThunk("fetchExecutiveCouncil", (params, {dispatch}) => {
    return get(params);
});


const postSlice = createSlice({
    name: 'executive-council',
    initialState,
    extraReducers: builder => {
        builder.addCase(fetchExecutiveCouncil.pending, (state) => {
            state.loading = true
            state.posts = []
            state.error = ''
        })
        builder.addCase(fetchExecutiveCouncil.fulfilled, (state, action) => {
            state.loading = false
            state.posts = action.payload
            state.error = ''

        })
        builder.addCase(fetchExecutiveCouncil.rejected, (state, action) => {
            state.loading = false
            state.posts = []
            state.error = action.error
        })
    }
})


export default postSlice.reducer
